import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a number as Indonesian Rupiah (IDR)
 * @param value - The number to format
 * @param options - Formatting options
 * @returns Formatted IDR string (e.g., "Rp45.231.891")
 */
export function formatIDR(
  value: number | string | null | undefined,
  options: {
    withSymbol?: boolean
    decimals?: number
  } = {}
): string {
  const { withSymbol = true, decimals = 0 } = options
  
  // Handle null/undefined values
  if (value === null || value === undefined) {
    return withSymbol ? 'Rp0' : '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof value === 'string' ? parseFloat(value) : value
  
  // Handle invalid numbers
  if (isNaN(numValue)) {
    return withSymbol ? 'Rp0' : '0'
  }
  
  // Format with Indonesian thousand separators (using dots)
  const formatted = numValue.toLocaleString('id-ID', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: true
  })
  
  return withSymbol ? `Rp${formatted}` : formatted
}
